import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationCreate, NotificationType } from '../interfaces/notifications-interface';
import { lastValueFrom, Observable } from 'rxjs';
import { API_ROUTES } from '../api/api-routes';
import { DEFAULT_JSON_HEADERS } from '../api/headers.config';

@Injectable({
  providedIn: 'root'
})
export class SendNotificationService {

  constructor(private http: HttpClient) { }

  // POST
  notifyMe(notification: NotificationCreate): Observable<any> {
    const payload = JSON.stringify(notification);

    return this.http.post<string>(
      `${API_ROUTES.NOTIFICATIONS.SEND_TO_ME}`,
      payload,
      {
        headers: DEFAULT_JSON_HEADERS
      }
    );
  }

  async sendFailedUploadNotification(failedCount: number, failedFileNames: string) {
    const notification: NotificationCreate = {
      title: 'notification.file_uploads_failed',
      body: 'notification.file_uploads_failed_title',
      is_read: false,
      type: NotificationType.ALERT,
      translate_in_frontend: true,
      title_params: {
        failed: failedCount.toString()
      },
      body_params: {
        files: failedFileNames
      }
    };

    try {
      await lastValueFrom(this.notifyMe(notification));
    } catch (error) {
      //pass
    }
  }
}
